const FORM_SELECTOR = '.wFormContainer, .wForm';

const FormAssemblyFix = {
	init() {
		this.fixMultipleSelects();
		this.deferUnloadWarning();
	},

	fixMultipleSelects() {
		const multiSelects = document.querySelectorAll('select[multiple][id^="tfa_"]');

		multiSelects.forEach(select => {
			select.removeAttribute('multiple');
		});
	},

	deferUnloadWarning() {
		const paging = window.wFORMS?.behaviors?.paging;
		if (!paging || !document.querySelector(FORM_SELECTOR)) return;

		paging.warnOnUnload = false;

		const arm = (event) => {
			if (!event.isTrusted || !event.target.closest?.(FORM_SELECTOR)) return;

			paging.warnOnUnload = true;
			document.removeEventListener('input', arm, true);
			document.removeEventListener('change', arm, true);
		};

		document.addEventListener('input', arm, true);
		document.addEventListener('change', arm, true);
	},
};

export default FormAssemblyFix;
